import React from "react";
import { Link } from "react-router-dom";
import { getSpecialities } from "./Navbar";

function Footer({ setTab, specialityId, setSpecialityId }) {
  return (
    <footer className="footer ttm-bgcolor-darkgrey widget-footer ttm-bgimage-yes ttm-bg clearfix">
      <div className="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
      <div className="second-footer">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_text clearfix">
                <div className="site-branding ">
                  <Link
                    to="/"
                    className="home-link"
                    title="Prasad Eye Hospital"
                    onClick={() => setTab("home")}
                  >
                    <img
                      id="logo-img"
                      className="img-center"
                      src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/logo.png"
                      alt="logo"
                    />
                  </Link>
                </div>
                <div className="textwidget widget-text">
                  <p>
                    Prasad Eye Hospital committed to provide the best services
                    in eye care through best improvements of systems, process,
                    technology.
                  </p>
                  <ul className="widget_contact_wrapper">
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-phone"></i>{" "}
                      <a href="tel:7970479666">+91 7970479666</a>
                    </li>
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-envelope-o"></i>
                      <a href="mailto:prasadeyehospital021@gmail.com">
                        {" "}
                        prasadeyehospital021@gmail.com
                      </a>
                    </li>
                    <li>
                      <i className="ttm-textcolor-skincolor fa fa-map-marker"></i>
                      Thana Chowk, Ramgarh - 829122, Jharkhand, India
                    </li>
                    <ul style={{ display: "flex" }}>
                      <li className="facebook-icon">
                        <a
                          href="https://www.facebook.com/pehramgarh/"
                          aria-label="facebook"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="instagram-icon">
                        <a
                          href="https://www.instagram.com/pehramgarh/"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="instagram"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="twitter-icon">
                        <a
                          href="https://x.com/PEH_Ramgarh/"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="twitter"
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="youtube-icon">
                        <a
                          href="https://www.youtube.com/@prasadeyehospital"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="youtube"
                        >
                          <i className="fa fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_nav_menu clearfix">
                <h3 className="widget-title">Quick Links</h3>
                <ul id="menu-footer-service-link" className="menu">
                  <li>
                    <Link to="/about" onClick={() => setTab("about")}>
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/appointment"
                      onClick={() => setTab("appointment")}
                    >
                      Appointment
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/blogs">Blogs</Link>
                  </li>
                  <li>
                    <Link to="/gallery">Gallery</Link>
                  </li> */}
                  <li>
                    <Link to="/contactus" onClick={() => setTab("contactus")}>
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/t&c" onClick={() => setTab("home")}>
                      Terms and Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" onClick={() => setTab("home")}>
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_nav_menu clearfix">
                <h3 className="widget-title">Specialities</h3>
                <ul id="menu-footer-quick-link" className="menu">
                  {getSpecialities(
                    specialityId,
                    () => {},
                    setTab,
                    setSpecialityId
                  )}
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
              <div className="widget widget-timing clearfix">
                <h3 className="widget-title">Opening Hours</h3>
                <div className="ttm-timelist-block-wrapper">
                  <ul className="ttm-timelist-block">
                    <li>
                      Monday:<span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Tuesday:
                      <span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Wednesday:
                      <span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Thursday:
                      <span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Friday:<span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Saturday:
                      <span className="service-time">10 AM - 06 PM</span>
                    </li>
                    <li>
                      Sunday:<span className="service-time">10 AM - 06 PM</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-footer-text ttm-bgcolor-darkgrey">
        <div className="container">
          <div className="row copyright">
            <div className="col-md-12">
              <div className="text-center">
                <span>
                  Copyright © 2021{" "}
                  <a href="/" onClick={() => setTab("home")}>
                    Prasad Eye Hospital
                  </a>{" "}
                  . All Rights Reserved | Powered By&nbsp;
                  <a
                    href="https://www.linkedin.com/company/appthing/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    AppThing Technologies
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
